function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["className", "children", "component", "onResize", "style", "timeout"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { node, string, elementType, func, object } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { useResize } from '../hooks';

/**
 * This component animates transitions of height for its contents.
 */
var SovosResizeContainer = function SovosResizeContainer(_ref) {
  var className = _ref.className,
    children = _ref.children,
    Component = _ref.component,
    onResize = _ref.onResize,
    styleProp = _ref.style,
    timeout = _ref.timeout,
    rest = _objectWithoutProperties(_ref, _excluded);
  var StyledComponent = useMemo(function () {
    return styled(Component)(function (_ref2) {
      var transitions = _ref2.theme.transitions;
      return {
        transitionTimingFunction: 'ease-in-out',
        transitionProperty: 'height',
        overflowX: 'visible',
        overflowY: 'clip',
        transitionDuration: "".concat(transitions.duration.standard, "ms")
      };
    });
  }, [Component]);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    wrapperStyles = _useState2[0],
    setWrapperStyles = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var wrapperRef = useRef(null);
  useResize(wrapperRef);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function () {
    var heightProp = styleProp === null || styleProp === void 0 ? void 0 : styleProp.height;
    var prevHeight = wrapperStyles === null || wrapperStyles === void 0 ? void 0 : wrapperStyles.height;
    var height = heightProp || wrapperRef.current.scrollHeight;
    var currentWidth = wrapperRef.current.scrollWidth;
    if (onResize && (prevHeight !== height || width !== currentWidth)) {
      onResize({
        height: height,
        width: currentWidth
      });
      setWidth(currentWidth);
    }
    if (height !== prevHeight) {
      var transitionDuration = function () {
        if (typeof timeout === 'number') return "".concat(timeout, "ms");
        if (timeout === 'auto') {
          if (!prevHeight) return 0;
          return "".concat(Math.abs(height - prevHeight) / 1.6 + 50, "ms");
        }
        return undefined;
      }();
      var newStyles = {
        height: height,
        transitionDuration: transitionDuration
      };
      setWrapperStyles(newStyles);
    }
  });
  return /*#__PURE__*/React.createElement(StyledComponent, _extends({
    className: clsx('SovosResizeContainer', className),
    style: _objectSpread(_objectSpread({}, wrapperStyles), styleProp)
  }, rest), /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, children));
};
SovosResizeContainer.propTypes = {
  /**
   * The content of the container
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * The component used for the root node. Either a string to use a HTML
   * element or a component
   */
  component: elementType,
  /**
   * Callback triggered when the height of the component's content changes,
   * at the start of the animation `function(newSize: {height: number,
   * width: number }) => void`
   */
  onResize: func,
  /**
   * Inline styles applied to the root element. Height can be passed in
   * here to disable resizing
   */
  style: object,
  /**
   * The duration for the transition, in milliseconds. Set to 'auto' to
   * automatically calculate transition time based on height. Default is
   * theme.transitions.duration.standard
   */
  timeout: function timeout(_ref3) {
    var prop = _ref3.timeout;
    if (prop === 'auto' || typeof prop === 'number' || prop === undefined) {
      return undefined;
    }
    return new Error("Invalid type supplied to SovosResizeContainer. Expected either a number of 'auto' but received ".concat(prop));
  }
};
SovosResizeContainer.defaultProps = {
  className: undefined,
  component: 'div',
  onResize: undefined,
  style: undefined,
  timeout: undefined
};
export default SovosResizeContainer;